import { useState, useCallback } from 'react';
import { getFeeds } from '../api/feedsHttpClient';
import { Feed } from '../api/models/Feed';

export const useFeeds = () => {
  const [feeds, setFeeds] = useState<Feed[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchFeeds = useCallback(
    async (projectId: string, toolId: string) => {
      setLoading(true);
      setError(null);
      try {
        const data = await getFeeds(projectId, toolId);
        setFeeds(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    feeds,
    loading,
    error,
    fetchFeeds,
  };
};
